import { render, staticRenderFns } from "./mockorg.vue?vue&type=template&id=37bd71ae&scoped=true&"
import script from "./mockorg.vue?vue&type=script&lang=js&"
export * from "./mockorg.vue?vue&type=script&lang=js&"
import style0 from "./mockorg.vue?vue&type=style&index=0&id=37bd71ae&prod&lang=scss&"
import style1 from "./mockorg.vue?vue&type=style&index=1&id=37bd71ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bd71ae",
  null
  
)

export default component.exports